import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/motion/Reveal";

export default function ServicesPage() {
  const { t } = useLanguage();
  useSEO({ title: t.services.seo.title, description: t.services.seo.description, path: "/services" });
  const s = t.services;

  return (
    <div data-testid="services-page" className="container-site py-14 sm:py-20 lg:py-28">
      <Reveal>
        <p className="eyebrow">{s.eyebrow}</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight">{s.title}</h1>
        <p className="mt-5 max-w-2xl text-base sm:text-lg text-muted-foreground leading-relaxed">{s.intro}</p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-10 max-w-3xl rounded-xl border border-dashed border-border bg-sand-muted/50 p-6 sm:p-10">
          <h2 className="text-sm font-mono uppercase tracking-[0.18em] font-semibold text-muted-foreground">
            {s.noteTitle}
          </h2>
          <p className="mt-3 text-muted-foreground leading-relaxed">{s.note}</p>
          <Link
            to="/contact"
            data-testid="services-contact-cta"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-ochre active:scale-[0.98]"
          >
            {s.cta}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
